import React, { useEffect } from "react";
import { useOptimizerNavigation } from "./useOptimizerNavigation";
import RuvnlOptimizerDas from "./OptimizerDas";

import RuvnlSimulationIndex from "./SimulationOptimizer/SimulationIndex";
import RuvnlSimulationOptimization from "./SimulationOptimizer/OptimizationIndex";
import { getGNAOptimizerSession } from "../../Rajasthan/Utility/RestApi";
import {
  setOptimizerDateRange,
} from "../../../store/state/GNAOptimizer/OptimizerDate";
import { setOptimizerRuvnlSession } from "../../../store/state/GNAOptimizer/OptimizerSession";
import { setOptimizerRuvnlSessionToken } from "../../../store/state/GNAOptimizer/OptimizerSessionToken";
import { useDispatch } from "react-redux";

const OptimizerRouter: React.FC = () => {
  const { currentPage } = useOptimizerNavigation();
  const dispatch = useDispatch();

  useEffect(() => {
    async function OptimizerRuvnlSession() {
      const data = await getGNAOptimizerSession();
      if (data) {
        dispatch(setOptimizerDateRange({ startDate: data.start_date , endDate: data.end_date}));
        dispatch(setOptimizerRuvnlSession(data.session));
        dispatch(setOptimizerRuvnlSessionToken(data.session_token));
      }
    }
    OptimizerRuvnlSession();
  }, [dispatch]);
  // Render the appropriate component based on the current page
  const renderPage = () => {
    switch (currentPage) {
      case "generation":
        return <RuvnlSimulationIndex />;
      case "optimisation":
        return <RuvnlSimulationOptimization />;
      default:
        return <RuvnlOptimizerDas />;
    }
  };

  return <>{renderPage()}</>;
};

export default OptimizerRouter;
